// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { cartLineWithNotes } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { cardStyles } from "@conklin/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cardStyles.productDescriptionText = {
    ...cartLineSharedStyles.productDescription?.productDetailDescription,
};

cardStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cardStyles.productNameLink = {
    ...cartLineSharedStyles.productDescription?.productDetailLink,
};

cardStyles.totalStyles = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};

cardStyles.image = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

cardStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

cardStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.productPrice?.price?.priceText, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

cardStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.productPrice?.price?.unitOfMeasure?.unitOfMeasureText, {
        css: css`
            display: inline-flex;
            margin-left: 4px;
        `,
    }),
};

cardStyles.brandStyles = {
    nameLink: {
        css: css`
            font-weight: ${fontConfig.weight.regular};
            @media print {
                display: block;
                width: 100%;
            }
        `,
    },
};

cardStyles.qty = {
    valueText: {
        size: 14,
    },
};

cardStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 8px;
        @media print {
            display: block;
        }
    `,
};

cardStyles.notesTextArea = {
    css: css`
        &&& {
            resize: horizontal;
            max-width: 100%;
            opacity: 1;
            border-color: ${color("common.ui5", 0.33)};
        }
    `,
};

cardStyles.productAvailability = {
    errorWrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    messageGridItem: {
        css: css`
            &:not(:empty) {
                margin-bottom: 12px;
            }
        `,
    },
};

cardStyles.cartLineContainerStyles = cartLineWithNotes;
